import * as React from 'react';
import * as StringHelper from '@ms/utilities-strings/lib/index';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Dialog, DialogFooter, DialogType, IDialogStyles } from 'office-ui-fabric-react/lib/Dialog';
import { Button } from 'office-ui-fabric-react/lib/Button';
import { CancelError } from '../../../utilities/async/CancelError';
import strings from './MalwareDetectedMessage.resx';
import { IMalwareDetectedWizardProps } from '../../../controls/malwareDetectedControl';
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

export class MalwareDetectedDialog extends React.PureComponent<IMalwareDetectedWizardProps> {
  private _infectedUrl: string | undefined;
  private _allowInfectedDownload: boolean | undefined;

  constructor(props: IMalwareDetectedWizardProps) {
    super(props);
    this._infectedUrl = props.infectedItemUrl;
    this._allowInfectedDownload = props.allowInfectedDownload;
  }

  public render(): JSX.Element | null {
    const onDismiss = () => {
      this.props.reject(new CancelError());
    };

    const onClickDownload = () => {
      const itemUrl = addMalwareDetectedQueryString(this._infectedUrl!);
      let target = window.open('', '_blank');
      if (target) {
        target.location.href = itemUrl;
      }
      this.props.resolve();
    };
    const theme = getTheme();
    const malwareDetectedFormat = this._allowInfectedDownload ?
      strings.malwareDetectedAllowDownloadMessage : strings.malwareDetectedMessage;
    return (
      <Dialog
        isOpen={ true }
        onDismiss={ onDismiss }
        title={ strings.malwareDetectedDialogHeader }
        closeButtonAriaLabel={ strings.closeButtonAriaLabel }
        type={ DialogType.close }
        getStyles={ getDialogOverrideStyle }
        dialogContentProps={ {
          getStyles: () => {
            return {
              title: {
                color: theme.semanticColors.errorText,
                fontWeight: '500'
              }
            };
          }
        } }
      >
        <Label>
          { StringHelper.formatToArray(malwareDetectedFormat,
            (
              <a href={ 'https://go.microsoft.com/fwlink/?linkid=862871' } target='_blank'>
                { strings.malwareDetectedLearnMore }
              </a>
            ))
          }
        </Label>
        <DialogFooter>
          ( !!this._allowInfectedDownload ?
          <Button
            onClick={ onClickDownload }
            primary={ true }
          >
            { strings.malwareDialogDownload }
          </Button> : null )
          <Button
            onClick={ onDismiss }
            primary={ true }
          >
            { strings.malwareDialogNo }
          </Button>
        </DialogFooter>
      </Dialog>
    );
  }
}

function getDialogOverrideStyle(): Partial<IDialogStyles> {
  return {
    main: {
      maxWidth: '450px !important'
    }
  };
}

function addMalwareDetectedQueryString(url: string): string {
  let itemUrl = url;
  if (itemUrl) {
    if (itemUrl.indexOf('?') === -1) {
      itemUrl += '?avcmd=1';
    } else {
      itemUrl += '&avcmd=1';
    }
  }
  return itemUrl;
}